import React from "react";
import AccordionComp from "../Components/AccordionComp";
import Waitlist from "./Waitlist";

interface WaitlistAccordionProps {
  waitlist: Record<string, boolean>;
  playerlist: Record<string, any>;
}

const WaitlistAccordion: React.FC<WaitlistAccordionProps> = ({
  waitlist,
  playerlist,
}) => {
  return (
    <AccordionComp title="Waitlist" list={waitlist}>
      <Waitlist waitlist={waitlist} playerlist={playerlist} />
    </AccordionComp>
  );
};

export default WaitlistAccordion;
